var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{staticClass:"search-input",attrs:{"type":"search","placeholder":_vm.$props.placeholderName},on:{"input":_vm.getListBySearch},model:{value:(_vm.searchModel),callback:function ($$v) {_vm.searchModel=$$v},expression:"searchModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }